module.exports = __webpack_public_path__ + "media/images/icons/people-outline-1d84e28b10e47bd0457e5b430aa33f2d.svg";